// extracted by mini-css-extract-plugin
export default {"root":"cH-sbPRSGsCsAH3UJ-psb"};